import { render, staticRenderFns } from "./RepresentativeForm.vue?vue&type=template&id=5a81e972&scoped=true"
import script from "./RepresentativeForm.vue?vue&type=script&lang=js"
export * from "./RepresentativeForm.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeForm.vue?vue&type=style&index=0&id=5a81e972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a81e972",
  null
  
)

export default component.exports